<template>
  <div id="sidebar-private-plot-item">
    <vx-card class="mt-4">
      <vs-row vs-type="flex" vs-justify="center" vs-align="center">
        <vs-col vs-w="2">
          <img class="icon-size" :src="img" />
        </vs-col>
        <vs-col vs-w="7">
          <div class="aisea-text-14-400-white">{{ title }}</div>
          <div class="plot-range-datetime">
            <vs-divider class="mt-1 mb-1" :color="AISEA_COLOR.GRAY"
              ><span class="aisea-text-12-400-white">表示期限</span>
            </vs-divider>
            <vs-row
              class="mt-1 aisea-text-12-400-white"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <vs-col vs-w="3">開始</vs-col>
              <vs-col vs-w="9">
                <span>
                  {{ startDate }}
                </span>
              </vs-col>
            </vs-row>
            <vs-row
              class="mt-1 aisea-text-12-400-white"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
            >
              <vs-col vs-w="3">終了</vs-col>
              <vs-col vs-w="9">
                <span>
                  {{ endDate }}
                </span>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
        <vs-col vs-w="3" vs-justify="flex-end" vs-type="flex">
          <vs-button
            class="mr-2"
            size="small"
            :color="btnStyle.color"
            type="filled"
            icon-pack="feather"
            icon="icon-map-pin"
            @click="jumpToPlot(plot)"
          ></vs-button>
          <vs-button
            size="small"
            :color="btnStyle.color"
            type="filled"
            icon-pack="feather"
            icon="icon-info"
            @click="showDetails()"
          ></vs-button>
        </vs-col>
      </vs-row>
    </vx-card>
  </div>
</template>

<script>
import { PLOT_CHILD_CATEGORY } from "@/config/const";
import moment from "moment";
import { ColorMixin } from "@/mixins";

export default {
  mixins: [ColorMixin],
  props: {
    plot: {
      type: Object,
      default: null,
    },
    jumpToPlot: {
      type: Function,
    },
  },
  data() {
    return {
      btnStyle: {
        color: "#549BD4",
      },
      defaultValues: {
        noneDate: "---",
        noneText: "",
      },
    };
  },
  computed: {
    // タイトル
    title() {
      if (!this.plot) return this.defaultValues.noneText;
      return this.plot.title ? this.plot.title : this.defaultValues.noneText;
    },
    // 開始日時
    startDate() {
      if (!this.plot) return this.defaultValues.noneDate;
      if (!this.plot.start_date) return this.defaultValues.noneDate;
      return this.plot.start_date.seconds != null
        ? moment(this.plot.start_date.seconds * 1000).format("YYYY/MM/DD HH:mm")
        : this.defaultValues.noneDate;
    },
    // 終了日時
    endDate() {
      if (!this.plot) return this.defaultValues.noneDate;
      if (!this.plot.end_date) return this.defaultValues.noneDate;
      return this.plot.end_date.seconds != null
        ? moment(this.plot.end_date.seconds * 1000).format("YYYY/MM/DD HH:mm")
        : this.defaultValues.noneDate;
    },
    // アイコン
    img() {
      if (!this.plot) return this.defaultValues.noneText;
      if (!this.plot.plot_child_category_id) return this.defaultValues.noneText;
      return require("@/assets/images/plot/" +
        PLOT_CHILD_CATEGORY.properties[this.plot.plot_child_category_id].img +
        ".png");
    },
  },
  methods: {
    showDetails() {
      const fromLiveMap = this.$route.name === "enterprise-live-map";
      this.$router.push({
        name: "enterprise-private-plot-edit",
        params: { hash: this.plot.hash, fromLiveMap },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

#sidebar-private-plot-item {
  .icon-size {
    height: 2rem;
  }

  .plot-range-datetime {
    color: gray;
    font-size: 0.8rem;
  }

  .vx-card {
    background: $aisea-blue-gray;
  }
}
</style>
